/**
 * `react-docgen` will throw on an `import` statement inside of a component:
 * `"did not recognize object of type \"ImportExpression\""`
 * To workaround this, we just move it to another file side-by-side the component
 *
 * Also the reason why we need two separate functions for V4 and V5
 *
 * Note: the partial import path is required to be inside this import statement,
 * otherwise webpack will complain that it's too dynamic.
 * `Critical dependency: the request of a dependency is an expression`
 **/
export const asyncImportV4SVG = async (name: string) =>
  // Note that this `.svg` is replaced by `.js` during the build
  // since `.svg` files will be transpiled to `.js`.
  await import(`./icons/V4/${name}.svg`);

export const asyncImportV5SVG = async (name: string) =>
  // Note that this `.svg` is replaced by `.js` during the build
  // since `.svg` files will be transpiled to `.js`.
  await import(`./icons/V5/${name}.svg`);
